import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/settings/integrations/apple-health",
)({
  component: () => {
    return <Outlet />;
  },
  staticData: {
    getBreadcrumb({ pathname }) {
      const isExact = pathname === "/settings/integrations/apple-health";
      return {
        href: "/settings/integrations/apple-health",
        label: isExact ? undefined : "Apple Health",
      };
    },
  },
});
